import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/header/AdminHeader'
import Footer from '../../components/footer/Footer'
import useAdminItemStore from '../../stores/admin/itemStore'
import useToastStore from '../../stores/toastStore'
import default_icon from '../../assets/images/box-item/logo-csgo.png'
import {
    csvHeaders,
    optionsStatus,
    optionsDemand,
    optionsSourceIn,
    optionsSourceOut,
    optionsVPS,
    optionsWaxType,
    optionsIsWebType,
    optionsUpdateType,
    optionsIsWebPopular,
    optionsIsWebBuying,
    optionsSteamID,
} from './data/steam_log_options'

// Table
import { DataGrid, GridEditInputCell } from '@mui/x-data-grid'
import { styled } from '@mui/material/styles' // Sử dụng styled từ MUI v5
import { Select, MenuItem } from '@mui/material'

// CSV
import { CSVLink } from 'react-csv'

import ChangeImageModal from '../../components/layouts/ChangeImageModal'

const CustomDataGrid = styled(DataGrid)(({ theme }) => {
    const pastelColors = {
        aqua: '#a7e6e6',
        yellow: '#fff9b3',
        green: '#b9f6b9',
    }

    return {
        '& .aqua-header': {
            backgroundColor: pastelColors.aqua,
        },
        '& .aqua-cell': {
            backgroundColor: pastelColors.aqua,
        },
        '& .yellow-header': {
            backgroundColor: pastelColors.yellow,
        },
        '& .yellow-cell': {
            backgroundColor: pastelColors.yellow,
        },
        '& .green-header': {
            backgroundColor: pastelColors.green,
        },
        '& .green-cell': {
            backgroundColor: pastelColors.green,
        },
    }
})

function EditInputCell(props) {
    const { error } = props

    return <GridEditInputCell {...props} />
}

function renderEditName(params) {
    return <EditInputCell {...params} />
}

export default function BasicEditingGrid() {
    const { fetchItems, items, updateItem, validationErrors } = useAdminItemStore()
    const [rows, setRows] = useState([])
    const [isShowFilter, setIsShowFilter] = useState(true)
    const { addToast, removeToast } = useToastStore()
    const params = {}
    const [showImageModal, setShowImageModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)

    useEffect(() => {
        fetchItems(params)
    }, [fetchItems])

    useEffect(() => {
        setRows(items)
    }, [items])

    const preProcessEditCellProps = async (params) => {
        // console.log(validationErrors)
        // const errorMessage = await validateName(params.props.value.toString())
        return { ...params.props }
    }

    const csvReport = {
        data: rows,
        headers: csvHeaders,
        filename: 'steam_logs.csv',
    }

    const totalPrice = rows.reduce((sum, row) => sum + row.price, 0);
    const formattedTotalPrice = totalPrice.toLocaleString('ja-JP', {
        style: 'currency',
        currency: 'JPY',
    });

    const columnDefs = [
        {
            headerName: 'ID',
            field: 'id',
            width: 50,
            type: 'numeric',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'VPS',
            field: 'vps_ip',
            width: 120,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Steam ID',
            field: 'steam_account_id',
            width: 140,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Image',
            field: 'images',
            width: 50,
            sortable: false,
            editable: false,
            align: 'center',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
            renderCell: (params) => (
                <img
                    src={params.value[0] ? params.value[0].url : default_icon}
                    alt="Item"
                    style={{ width: '30px', height: '30px', cursor: 'pointer', borderRadius: 0 }}
                    onClick={() => {
                        setSelectedItem(params.row)
                        setShowImageModal(true)
                    }}
                    title="Click to change image"
                />
            ),
        },
        {
            headerName: 'Pattern',
            field: 'pattern',
            width: 90,
            type: 'text',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Item ID',
            field: 'steam_item_id',
            width: 100,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Item Name',
            field: 'name',
            width: 250,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
            renderCell: (params) => {
              return params.row.buff_link ? (
                <a
                  href={params.row.buff_link}
                  style={{ color: "blue", textDecoration: "underline" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {params.value}
                </a>
              ) : (
                <span>{params.value}</span> // Hiển thị text bình thường nếu không có buff_link
              );
            },
        },
        {
            headerName: 'Buff Price (¥)',
            field: 'buff_price',
            width: 70,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Float',
            field: 'float_num',
            width: 70,
            type: 'numeric',
            editable: true,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'True Price (¥)',
            field: 'price',
            width: 70,
            type: 'numeric',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Source In',
            field: 'source_in',
            width: 60,
            type: 'text',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    <MenuItem key={null} value={null}>
                        Xoá
                    </MenuItem>
                    {optionsSourceIn.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Buy Price',
            field: 'buy_price',
            width: 60,
            type: 'numeric',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'TBP',
            field: 'time_buy_price',
            width: 60,
            type: 'numeric',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Source Out',
            field: 'source_out',
            width: 60,
            type: 'text',
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    <MenuItem key={null} value={null}>
                        Xoá
                    </MenuItem>
                    {optionsSourceOut.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Sold Price',
            field: 'sold_price',
            width: 60,
            type: 'numeric',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Buy Date',
            field: 'buy_date',
            width: 85,
            type: 'date',
            editable: true,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
            valueGetter: (params) => {
                return params ? new Date(params) : null // Chuyển đổi thành đối tượng Date
            },
        },
        {
            headerName: 'Sold Date',
            field: 'sold_date',
            width: 85,
            type: 'date',
            editable: true,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
            valueGetter: (params) => {
                return params ? new Date(params) : null // Chuyển đổi thành đối tượng Date
            },
        },
        {
            headerName: 'Day Time',
            field: 'days_locked',
            width: 50,
            type: 'numeric',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            align: 'right',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Status',
            field: 'status',
            width: 80,
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsStatus.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Update Type',
            field: 'update_type',
            width: 80,
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsUpdateType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Wax Type',
            field: 'wax_type',
            width: 70,
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsWaxType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Is Web Type',
            field: 'is_web_type',
            width: 70,
            renderCell: (params) => <span>{params.value ? 'On' : 'Off'}</span>,
            renderEditCell: (params) => (
                <Select
                    value={params.value}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsIsWebType.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Is Web Popular',
            field: 'is_web_popular',
            width: 70,
            renderCell: (params) => <span>{params.value ? 'Yes' : 'No'}</span>,
            renderEditCell: (params) => (
                <Select
                    value={params.value}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsIsWebPopular.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Is Web Buying',
            field: 'is_web_buying',
            width: 70,
            renderCell: (params) => <span>{params.value ? 'Yes' : 'No'}</span>,
            renderEditCell: (params) => (
                <Select
                    value={params.value}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    {optionsIsWebBuying.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Demand',
            field: 'demand',
            width: 80,
            renderEditCell: (params) => (
                <Select
                    value={params.value || ''}
                    onChange={(event) =>
                        params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })
                    }
                    fullWidth
                >
                    <MenuItem key={null} value={null}>
                        Xoá
                    </MenuItem>
                    {optionsDemand.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            ),
            editable: true,
            preProcessEditCellProps,
            align: 'center',
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'CBP ',
            field: 'convert_buy_price',
            width: 80,
            type: 'text',
            editable: false,
            align: 'right',
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
        {
            headerName: 'CSP',
            field: 'convert_sold_price',
            width: 80,
            type: 'text',
            editable: false,
            align: 'right',
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
        {
            headerName: 'Trend (%)',
            field: 'trend_price',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
        {
            headerName: 'Profit (%)',
            field: 'profit_percentage',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
        {
            headerName: 'Profit',
            field: 'profit',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
        {
            headerName: 'Wax Min Sell',
            field: 'wax_min_sale',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Wax True Sell Point',
            field: 'wax_true_sell_point',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Wax Time Sell Point',
            field: 'wax_time_sell_point',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Wax Null Sell Point',
            field: 'wax_null_sell_point',
            width: 80,
            type: 'numeric',
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Web Price',
            field: 'web_price',
            width: 90,
            type: 'numeric',
            valueFormatter: (params) => {
              // Sử dụng Intl.NumberFormat để định dạng tiền tệ
              return new Intl.NumberFormat('en-US').format(params);
            },
            editable: false,
            align: 'right',
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Updated At',
            field: 'updated_at',
            width: 140,
            type: 'dateTime',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
            valueFormatter: (value) => {
                if (value == null || value === '') return ''
                const d = new Date(value)
                return isNaN(d.getTime()) ? String(value) : d.toLocaleString()
            },
        },
    ]

    const processRowUpdate = async (newRow) => {
        try {
            // Loại bỏ field 'images' khỏi newRow
            const { images, ...rowWithoutImage } = newRow;

            // Gọi API update với object đã loại bỏ 'image'
            const res = await updateItem(rowWithoutImage.id, rowWithoutImage);
            if (res.success) {
                addToast('Update thành công!', 'success')
                // Cập nhật newRow với dữ liệu từ response
                const updatedRow = { ...newRow, ...res.data }

                // Cập nhật hàng với dữ liệu mới
                const updatedRows = rows.map((row) => (row.id === newRow.id ? updatedRow : row))
                setRows(updatedRows)

                return updatedRow
            } else {
                removeToast()
                Object.keys(res.messages).forEach((key) => {
                    const errorMessages = res.messages[key].join(', ')
                    addToast(`${key}: ${errorMessages}`, 'danger')
                })

                // Nếu thất bại, trả về hàng ban đầu
                return newRow
            }
        } catch (error) {
            console.error('Failed to update the item:', error)
            throw error
        }
    }

    const [filters, setFilters] = useState({
        status: 'active',
        vps_ip: '',
        demand: '',
        name: '',
        source_in: '',
        source_out: '',
        min_price: '',
        max_price: '',
        min_profit: '',
        max_profit: '',
        min_profit_percentage: '',
        max_profit_percentage: '',
        min_trend_price: '',
        max_trend_price: '',
        min_web_price: '',
        max_web_price: '',
        min_buy_date: '',
        max_buy_date: '',
        min_sold_date: '',
        max_sold_date: '',
        min_locked_days: '',
        max_locked_days: '',
        wax_type: '',
        is_web_type: '',
        is_web_popular: '',
        is_web_buying: '',
        update_type: '',
        steam_account_id: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        setFilters({
            ...filters,
            [name]: value,
        })
    }

    const handleClear = () => {
        setFilters({
            status: '',
            vps_ip: '',
            demand: '',
            name: '',
            source_in: '',
            source_out: '',
            min_price: '',
            max_price: '',
            min_profit: '',
            max_profit: '',
            min_profit_percentage: '',
            max_profit_percentage: '',
            min_trend_price: '',
            max_trend_price: '',
            min_web_price: '',
            max_web_price: '',
            min_buy_date: '',
            max_buy_date: '',
            min_sold_date: '',
            max_sold_date: '',
            min_locked_days: '',
            max_locked_days: '',
            wax_type: '',
            is_web_type: '',
            is_web_popular: '',
            is_web_buying: '',
            update_type: '',
            steam_account_id: '',
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        fetchItems(filters)
    }

    return (
        <div>
            <Header />
            <section className="steam_logs tf-section-admin">
                <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Steam Logs</h2>

                {isShowFilter && (
                    <div className="container-fluid b-1">
                        <div style={{ width: '100%' }}>
                            <form className="filter-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>True Price:</label>
                                    <div className="min-max">
                                        <input
                                            type="number"
                                            name="min_price"
                                            placeholder="Min"
                                            value={filters.min_price}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="number"
                                            name="max_price"
                                            placeholder="Max"
                                            value={filters.max_price}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Profit (%):</label>
                                    <div className="min-max">
                                        <input
                                            type="number"
                                            name="min_profit_percentage"
                                            placeholder="Min"
                                            value={filters.min_profit_percentage}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="number"
                                            name="max_profit_percentage"
                                            placeholder="Max"
                                            value={filters.max_profit_percentage}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Trend (%):</label>
                                    <div className="min-max">
                                        <input
                                            type="number"
                                            name="min_trend_price"
                                            placeholder="Min"
                                            value={filters.min_trend_price}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="number"
                                            name="max_trend_price"
                                            placeholder="Max"
                                            value={filters.max_trend_price}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Day Time:</label>
                                    <div className="min-max">
                                        <input
                                            type="number"
                                            name="min_locked_days"
                                            placeholder="Min"
                                            value={filters.min_locked_days}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="number"
                                            name="max_locked_days"
                                            placeholder="Max"
                                            value={filters.max_locked_days}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Buy Date:</label>
                                    <div className="min-max">
                                        <input
                                            type="date"
                                            name="min_buy_date"
                                            value={filters.min_buy_date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="date"
                                            name="max_buy_date"
                                            value={filters.max_buy_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Sold Date:</label>
                                    <div className="min-max">
                                        <input
                                            type="date"
                                            name="min_sold_date"
                                            value={filters.min_sold_date}
                                            onChange={handleChange}
                                        />
                                        <input
                                            type="date"
                                            name="max_sold_date"
                                            value={filters.max_sold_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Name:</label>
                                    <input type="text" name="name" value={filters.name} onChange={handleChange} />
                                </div>
                                <div className="form-group">
                                    <label>VPS IP:</label>
                                    <select name="vps_ip" value={filters.vps_ip} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsVPS.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Status:</label>
                                    <select name="status" value={filters.status} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsStatus.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Demand:</label>
                                    <select name="demand" value={filters.demand} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsDemand.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Source In:</label>
                                    <select name="source_in" value={filters.source_in} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsSourceIn.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Source Out:</label>
                                    <select name="source_out" value={filters.source_out} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsSourceOut.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Wax Type:</label>
                                    <select name="wax_type" value={filters.wax_type} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsWaxType.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Is Web Type:</label>
                                    <select name="is_web_type" value={filters.is_web_type} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsIsWebType.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Is Web Popular:</label>
                                    <select name="is_web_popular" value={filters.is_web_popular} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có l��a chọn */}
                                        {optionsIsWebPopular.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Is Web Buying:</label>
                                    <select name="is_web_buying" value={filters.is_web_buying} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsIsWebBuying.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Update Type:</label>
                                    <select name="update_type" value={filters.update_type} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsUpdateType.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Steam ID:</label>
                                    <select name="steam_account_id" value={filters.steam_account_id} onChange={handleChange}>
                                        <option value="">Chọn...</option> {/* Option trống khi chưa có lựa chọn */}
                                        {optionsSteamID.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="">
                                    <button type="submit" className="sc-button style-1 style hide-filter-btn">
                                        Lọc
                                    </button>
                                    <button
                                        className="sc-button style-1 style ml-10 hide-filter-btn"
                                        onClick={handleClear}
                                    >
                                        Xoá bộ lọc
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                <div className="container-fluid">
                    <button
                        className="sc-button style-1 style mb-4 hide-filter-btn"
                        onClick={() => setIsShowFilter(!isShowFilter)}
                    >
                        {isShowFilter ? 'Ẩn' : 'Hiển thị'} bộ lọc
                    </button>
                    <button className="sc-button style-1 style mb-4 ml-10 hide-filter-btn">
                        <CSVLink {...csvReport}>Xuất file CSV</CSVLink>
                    </button>

                    <h5 class="mb-11">Kết quả: {rows.length} items</h5>
                    <h6 class="mb-11">Total true price: {formattedTotalPrice}</h6>
                    <div style={{ height: '70vh', width: '100%' }}>
                        <CustomDataGrid
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'id', sort: 'desc' }],
                                },
                            }}
                            rows={rows}
                            columns={columnDefs}
                            processRowUpdate={processRowUpdate}
                            onProcessRowUpdateError={(error) => {
                                console.error('Row update error:', error)
                                alert('There was an error updating the row. Please try again.')
                            }}
                            rowHeight={30}
                            columnHeaderHeight={50}
                            editMode="row"
                            sx={{
                                borderColor: '#FFFFFF',
                                fontSize: 12,
                                fontWeight: 500,
                                '& .MuiDataGrid-cell': {
                                    color: 'black',
                                },
                                '& .MuiDataGrid-cell': {
                                    borderRight: '1px solid #ccc', // Đường viền giữa các ô dữ liệu
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    borderBottom: '2px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiInputBase-input': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-row--editing .MuiDataGrid-cell': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-footerContainer': {
                                    backgroundColor: 'cornflowerblue',
                                },
                                '.MuiTablePagination-selectLabel': {
                                    fontSize: 12,
                                },
                                '.MuiTablePagination-displayedRows': {
                                    fontSize: 12,
                                },
                                '& .custom-header': {
                                  whiteSpace: 'pre-line',
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    whiteSpace: 'normal',
                                    overflow: 'visible',
                                    textOverflow: 'clip',
                                    lineHeight: '1.2',
                                    wordWrap: 'break-word',
                                    height: 'auto', // Đảm bảo chiều cao tự động
                                    display: 'flex',
                                    alignItems: 'center', // Căn giữa nội dung theo chiều dọc
                                    borderRight: '1px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    overflow: 'visible',
                                    textAlign: 'center', // Căn giữa theo chiều ngang
                                    fontWeight: 800,
                                },
                            }}
                        />
                    </div>
                </div>
            </section>
            <ChangeImageModal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                item={selectedItem}
                onUpdate={(updatedItem) => {
                    const updatedRows = rows.map((row) => (row.id === updatedItem.id ? updatedItem : row))
                    setRows(updatedRows)
                }}
            />
        </div>
    )
}
